import { Link as InertiaLink } from '@inertiajs/react';
import { Link as RadixLink } from '@radix-ui/themes';
import useRouter from '@/hooks/useRouter';

export default function Link({ children, ...props }) {
  const { route } = useRouter();
  const href = route(props.href);

  return (
    <RadixLink asChild>
      <InertiaLink {...props} href={href}>
        {children}
      </InertiaLink>
    </RadixLink>
  );
}
